export default "__VITE_ASSET__DvLggU6N__$_?url__"